module.exports = __webpack_public_path__ + "img/hanhua.02293ade.png";